import type { ReactNode } from "react";
import { ContentContainer } from "./ContentContainer";
import { Header } from "./Header";

interface LeftPanelProps {
  children: ReactNode;
  progress?: {
    currentStep: number;
    totalSteps: number;
  };
  title?: ReactNode;
  subtitle?: ReactNode;
}

export const LeftPanel = ({
  children,
  progress,
  title,
  subtitle,
}: LeftPanelProps) => (
  <div className="animate-fade-in-slow flex w-full flex-col bg-white px-12 py-8 lg:w-1/2">
    <div className="flex flex-col">
      <Header progress={progress} />
      <ContentContainer title={title} subtitle={subtitle}>
        {children}
      </ContentContainer>
    </div>
  </div>
);
